import { IconButton, Stack } from '@mui/material';
import { ArrowLeft, X } from 'lucide-react';
import { SidePanelCaption } from 'src/components/SidePanelCaption/side-panel-caption';
import { toSxArray } from 'src/utils/sx';
import { getModalHeaderSx, modalIconButtonSx, modalTitleSx } from './modal-container.styles';
import type { ModalHeaderAction } from './modal-container.types';
import { MODAL_CLOSE_ATTRIBUTE, MODAL_DRAG_HANDLE_CLASS } from './modal-container.utils';

const HEADER_ICON_SIZE = 16;

interface ModalContainerHeaderProps {
  title: string;
  titleId?: string;
  titleTestId?: string;
  onClose: () => void;
  onBack?: () => void;
  headerActions?: ModalHeaderAction[];
  isScrolled: boolean;
  isSaving: boolean;
}

export const ModalContainerHeader = ({
  title,
  titleId,
  titleTestId,
  onClose,
  onBack,
  headerActions,
  isScrolled,
  isSaving,
}: ModalContainerHeaderProps) => (
  <Stack
    className={MODAL_DRAG_HANDLE_CLASS}
    direction="row"
    alignItems="center"
    gap={0.75}
    pr={1.75}
    pl={2.5}
    flexShrink={0}
    sx={getModalHeaderSx(isScrolled)}
  >
    {onBack ? (
      <IconButton
        size="small"
        aria-label="Back"
        onClick={onBack}
        disabled={isSaving}
        disableFocusRipple
        sx={[...toSxArray(modalIconButtonSx), { ml: -0.75 }]}
      >
        <ArrowLeft size={HEADER_ICON_SIZE} />
      </IconButton>
    ) : null}
    <SidePanelCaption
      component="h2"
      id={titleId}
      data-testid={titleTestId}
      noWrap
      sx={modalTitleSx}
    >
      {title}
    </SidePanelCaption>
    {headerActions?.map(({ label, icon, onClick, disabled, testId }) => (
      <IconButton
        key={label}
        size="small"
        aria-label={label}
        onClick={onClick}
        disabled={isSaving || disabled}
        disableFocusRipple
        data-testid={testId}
        sx={modalIconButtonSx}
      >
        {icon}
      </IconButton>
    ))}
    <IconButton
      size="small"
      aria-label="Close"
      onClick={onClose}
      disabled={isSaving}
      disableFocusRipple
      sx={modalIconButtonSx}
      {...{ [MODAL_CLOSE_ATTRIBUTE]: true }}
    >
      <X size={HEADER_ICON_SIZE} />
    </IconButton>
  </Stack>
);
